import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

interface EmptyStateProps {
  message?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message = 'Нет данных' }) => (
  <Box sx={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', py: 8, gap: 1.5, color: 'text.disabled',
  }}>
    <InboxIcon sx={{ fontSize: 48 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

export default EmptyState;
